import {
  StorageType,
  StorageUnit,
  ContentType,
  FileFormat,
} from '../models/upload-config.model';

export const FILE_FORMATS: FileFormat[] = [
  // Image formats
  { value: 'jpg', label: 'JPG' },
  { value: 'jpeg', label: 'JPEG' },
  { value: 'png', label: 'PNG' },
  { value: 'gif', label: 'GIF' },
  { value: 'bmp', label: 'BMP' },
  { value: 'webp', label: 'WebP' },
  { value: 'svg', label: 'SVG' },
  { value: 'tiff', label: 'TIFF' },

  // Document formats
  { value: 'pdf', label: 'PDF' },
  { value: 'doc', label: 'DOC' },
  { value: 'docx', label: 'DOCX' },
  { value: 'xls', label: 'XLS' },
  { value: 'xlsx', label: 'XLSX' },
  { value: 'ppt', label: 'PPT' },
  { value: 'pptx', label: 'PPTX' },
  { value: 'txt', label: 'TXT' },

  // Video formats
  { value: 'mp4', label: 'MP4' },
  { value: 'avi', label: 'AVI' },
  { value: 'mov', label: 'MOV' },
  { value: 'wmv', label: 'WMV' },
  { value: 'flv', label: 'FLV' },
  { value: 'webm', label: 'WebM' },

  // Audio formats
  { value: 'mp3', label: 'MP3' },
  { value: 'wav', label: 'WAV' },
  { value: 'flac', label: 'FLAC' },
  { value: 'aac', label: 'AAC' },

  // Archive formats
  { value: 'zip', label: 'ZIP' },
  { value: 'rar', label: 'RAR' },
  { value: '7z', label: '7Z' },
  { value: 'tar', label: 'TAR' },
  { value: 'gz', label: 'GZ' },
];

export const DEFAULT_MAX_FILES_FOR_DETAIL_IMAGES = 10;
export const MAX_FILES_FOR_DETAIL_IMAGES_LIMIT = 50;

// New constants for enhanced system
export const FILE_CATEGORIES = [
  { value: 'IMAGE', label: 'upload_detail_config.file_categories.IMAGE' },
  { value: 'DOCUMENT', label: 'upload_detail_config.file_categories.DOCUMENT' },
  { value: 'VIDEO', label: 'upload_detail_config.file_categories.VIDEO' },
  { value: 'AUDIO', label: 'upload_detail_config.file_categories.AUDIO' },
  { value: 'ARCHIVE', label: 'upload_detail_config.file_categories.ARCHIVE' },
  { value: 'OTHER', label: 'upload_detail_config.file_categories.OTHER' },
];

export const SIZE_UNITS = [
  { value: 'KB', label: 'upload_detail_config.size_units.KB' },
  { value: 'MB', label: 'upload_detail_config.size_units.MB' },
];

export const DEFAULT_FILE_SIZE_LIMIT = 5;
export const DEFAULT_SIZE_UNIT = 'MB';
export const DEFAULT_MAX_DETAIL_IMAGES = 5;

// Image file formats only
export const IMAGE_FILE_FORMATS = [
  { value: 'jpg', label: 'upload_detail_config.file_formats.jpg' },
  { value: 'jpeg', label: 'upload_detail_config.file_formats.jpeg' },
  { value: 'png', label: 'upload_detail_config.file_formats.png' },
  { value: 'webp', label: 'upload_detail_config.file_formats.webp' },
  { value: 'bmp', label: 'upload_detail_config.file_formats.bmp' },
  { value: 'svg', label: 'upload_detail_config.file_formats.svg' },
];

// Size validation limits
export const IMAGE_SIZE_LIMITS = {
  MB: { max: 2, min: 1 },
  KB: { max: 2048, min: 1 },
};
